import StringFormat, { formatMessage } from "./string-format";
import { PANDA_INSTANCES, PANDA_I18N_PACK } from "../../const";
import { debugInfo, debugError } from "../index";
import { i18nMapping } from "../../services";
import { pandaSelf } from "../../const/globalThis";
export function initial(locale, options) {
  var name = options.name,
    lang = options.lang,
    packageName = options.packageName,
    $i18n = options.$i18n;
  window[PANDA_INSTANCES] = window[PANDA_INSTANCES] || {};
  window[PANDA_INSTANCES][name] = new StringFormat({
    locale: locale,
    lang: lang,
    $i18n: $i18n,
    packageName: packageName
  });
}
export function format(des, variable, options) {
  var _ref = options || {},
    name = _ref.name,
    nameSpace = _ref.nameSpace,
    lang = _ref.lang,
    type = _ref.type,
    pure = _ref.pure;
  var instances = window[PANDA_INSTANCES] || {};
  // 当nameSpace不为空且不等于name时，则去找到ns相关实例
  var instance = null;
  if (!nameSpace || nameSpace === name || name.includes('.') && instances[name]) {
    instance = instances[name];
  } else {
    // 先行匹配于name后缀的，再匹配非name后缀的
    var instanceNames = Object.keys(instances);
    var findName = instanceNames.find(function (key) {
      return key.startsWith(nameSpace + '.' + name);
    }) || instanceNames.find(function (key) {
      return key.startsWith(nameSpace);
    });
    instance = findName ? instances[findName] : null;
  }
  if (!instance) {
    debugInfo("No translation found: " + name + " : " + des.id);
    return formatMessage(des.defaultMessage || des.id || '', variable);
  }
  // 兼容混合模式下不存在format2方法时的情况
  var _ref2 = instance.format2 ? instance.format2(des, variable, options) : {
      message: instance.format(des, variable, options),
      usedLang: lang,
      isMatched: true
    },
    message = _ref2.message,
    usedLang = _ref2.usedLang,
    isMatched = _ref2.isMatched;
  if ((window.__PANDA.isI18nPdkv || pandaSelf.debug) && !pure) {
    var _window$PANDA_I18N_PA, _window$PANDA_I18N_PA2, _window$PANDA_I18N_PA3, _window$PANDA_I18N_PA4;
    // 组件的名字来自于 nameSpace 或者 name的前置 如 MyComponent.1dfk23fg
    var componentName = nameSpace || (name.includes('.') ? name.split('.')[0] : '');
    // 如果设置了组件名或者包名，则认为不来自于CDN翻译
    var packId = !componentName ? (_window$PANDA_I18N_PA = window[PANDA_I18N_PACK]) === null || _window$PANDA_I18N_PA === void 0 ? void 0 : (_window$PANDA_I18N_PA2 = _window$PANDA_I18N_PA[usedLang.replace('-', '_')]) === null || _window$PANDA_I18N_PA2 === void 0 ? void 0 : (_window$PANDA_I18N_PA3 = _window$PANDA_I18N_PA2.copyList) === null || _window$PANDA_I18N_PA3 === void 0 ? void 0 : (_window$PANDA_I18N_PA4 = _window$PANDA_I18N_PA3[des.id]) === null || _window$PANDA_I18N_PA4 === void 0 ? void 0 : _window$PANDA_I18N_PA4.packId : '';
    // 反向获取语言包id
    return i18nMapping.encrypt(message, {
      copyKey: des.id,
      type: type,
      componentName: componentName,
      packageName: instance.packageName,
      packId: packId,
      isMatched: isMatched
    });
  }
  return message;
}
export function setLocaleToInstance(locale, name) {
  var instances = window[PANDA_INSTANCES] || {};
  var instance = instances[name];
  if (!instance) {
    debugInfo('No $i18n instance found');
    debugError({
      instanceName: name
    });
    return;
  }
  instance.setLocale(locale);
}